module.exports = __webpack_public_path__ + "img/available.823d0bec.svg";